import { render } from "./NewEventForm.vue?vue&type=template&id=c8fe6158"
import script from "./NewEventForm.vue?vue&type=script&lang=js"
export * from "./NewEventForm.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__